import { withNamespaces } from "react-i18next";
import { Text, View } from "@react-pdf/renderer";
import styles from "../../Styles";
import ReportContent from "./report";

const groupQuestionsBySection = (questions = []) => {
    const groupedQuestionsBySection = [];

    const findSection = (sectionName) => {
        return groupedQuestionsBySection.find((section) => {
            return section.name === sectionName;
        });
    };

    for (let i = 0; i < questions.length; i++) {
        const question = questions[i];
        let section = findSection(question.section || "");

        if (!section) {
            section = {
                name: question.section || "",
                items: [],
            };
            groupedQuestionsBySection.push(section);
        }

        section.items.push(question);
    }

    return groupedQuestionsBySection;
};

const Reports = ({
    t,
    reports = [],
    embedded = false,
}) => {
    const content = (
        <View style={embedded ? undefined : styles.section}>
            {reports.map((report, index) => {
                return (
                    <ReportContent
                        key={index}
                        sections={groupQuestionsBySection(report)}
                    />
                );
            })}
        </View>
    );

    if (embedded) {
        return content;
    }

    return (
        <View break>
            <View style={styles.sectionSeparator}>
                <Text>{t("REPORTS")}</Text>
            </View>

            {content}
        </View>
    );
};

export default withNamespaces()(Reports);